// EmailJS Configuration
// To set up EmailJS:
// 1. Go to https://www.emailjs.com/
// 2. Create an account and verify your email
// 3. Create a new service (Gmail, Outlook, etc.)
// 4. Create an email template
// 5. Get your Public Key from the Integration page
// 6. Replace the values below with your actual EmailJS credentials

export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_91p9q79', // Main service ID for admin notifications and contact form
  CONFIRMATION_SERVICE_ID: 'service_5hzje4v', // Service ID for user confirmation emails
  TEMPLATE_ID: 'template_fmizx9r', // Registration notification template ID (to admin)
  REGISTRATION_CONFIRMATION_TEMPLATE_ID: 'template_djkzj19', // Registration confirmation template ID (to user) - English
  REGISTRATION_CONFIRMATION_TEMPLATE_ID_AL: 'template_df92mbm', // Registration confirmation template ID (to user) - Albanian - REPLACE WITH YOUR ACTUAL TEMPLATE ID
  CONTACT_TEMPLATE_ID: 'template_glqvb0w', // Contact form template ID
  PUBLIC_KEY: 'jdOrBVflvRHOrYTyu', // Public key for main service
  CONFIRMATION_PUBLIC_KEY: 'GqnKx5Kn-fdBJ2OUK' // Public key for confirmation service - REPLACE WITH YOUR ACTUAL PUBLIC KEY
};

// Email template variables that will be sent:
// 
// For Registration Notification (to admin):
// - to_email: 'info@pejapeaceforum.org'
// - from_name: User's full name
// - from_email: User's email
// - phone: User's phone number
// - organization: User's organization
// - position: User's position
// - country: User's country
// - city: User's city
// - attendance_type: In-person or Virtual
// - interests: Comma-separated list of interests
// - how_did_you_hear: How they heard about the forum
// - additional_info: Additional information
// - message: Formatted message with all details
//
// For Registration Confirmation (to user):
// - to_email: User's email address
// - from_name: User's full name
// - from_email: User's email
// - organization: User's organization
// - attendance_type: In-person or Virtual
// - city: User's city
// - country: User's country
